import { render, staticRenderFns } from "./GuncellemelerDialog.vue?vue&type=template&id=33a8d98f&scoped=true"
import script from "./GuncellemelerDialog.vue?vue&type=script&lang=ts"
export * from "./GuncellemelerDialog.vue?vue&type=script&lang=ts"
import style0 from "./GuncellemelerDialog.vue?vue&type=style&index=0&id=33a8d98f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8d98f",
  null
  
)

export default component.exports